module.exports = __webpack_public_path__ + "img/3.f83e147b.png";